import GradientBorderRadius from "@/ui/gradient-border-radius";
import { IconComponent } from "@/ui/icon";

const DeleteWalletButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <GradientBorderRadius
      gradient="none"
      radius="circle"
      hover="r-100"
      background="black"
      active={undefined}
      className="w-[1.375rem] h-[1.375rem] flex items-center justify-center"
    >
      <button onClick={onClick}>
        <IconComponent name="trash" className="w-[0.75rem] h-[0.75rem]" />
      </button>
    </GradientBorderRadius>
  );
};

export default DeleteWalletButton;
